import { PropsWithChildren } from 'react';

import style from './form-field-grid-container.module.css';

interface FormFieldGridContainerProps {
  layoutGridColumnSpan: null | number | undefined;
}

const gridColumnSpanMap: Record<number, string> = {
  [1]: style.colSpan1,
  [2]: style.colSpan2,
  [3]: style.colSpan3,
  [4]: style.colSpan4,
  [5]: style.colSpan5,
  [6]: style.colSpan6,
  [7]: style.colSpan7,
  [8]: style.colSpan8,
  [9]: style.colSpan9,
  [10]: style.colSpan10,
  [11]: style.colSpan11,
  [12]: style.colSpan12,
};

const FormFieldGridContainer = ({
  children,
  layoutGridColumnSpan,
}: PropsWithChildren<FormFieldGridContainerProps>) => {
  return (
    <div className={gridColumnSpanMap[layoutGridColumnSpan ?? 12]}>
      {children}
    </div>
  );
};

export default FormFieldGridContainer;
